import { render, staticRenderFns } from "./TreeDirItem.vue?vue&type=template&id=794948e0&scoped=true"
import script from "./TreeDirItem.vue?vue&type=script&lang=js"
export * from "./TreeDirItem.vue?vue&type=script&lang=js"
import style0 from "./TreeDirItem.vue?vue&type=style&index=0&id=794948e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794948e0",
  null
  
)

export default component.exports